var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crew"},[_c('vmc-header'),_c('router-view'),_c('vmc-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }